import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import { Paper } from '@material-ui/core';
import classnames from 'classnames';
// SERVICES
import { createUnderwriterUser, getClientList } from '../../../services';

const styles = props => ({ paper: { padding: '24px', boxSizing: 'border-box' } });

export const UnderwriterUsersCreate = withStyles(styles)(({ classes }) => {
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getClientListAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  const underwriterUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'clientId',
              label: 'Client',
              validate: [v.required()],
              options: clientList,
            },
            {
              inputType: 'text',
              field: 'underwriterCode',
              label: 'Underwriter Code',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              validate: [v.required()],
            },
            {
              inputType: 'password',
              field: 'password',
              label: 'Password',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'fname',
              label: 'First Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'mname',
              label: 'Middle Name',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'lname',
              label: 'Last Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'title',
              label: 'Title',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'company',
              label: 'Company',
              validate: [v.required()],
            },

            {
              inputType: 'boolean',
              field: 'recordMode',
              label: 'Record Mode',
              validate: [],
            },
            {
              inputType: 'boolean',
              field: 'emailOutput',
              label: 'Email Output',
              validate: [],
            },
            {
              inputType: 'boolean',
              field: 'receivesImportVerification',
              label: 'Receives Import Verification Email',
              validate: [],
            },
          ],
        },
      ],
    },
  ];

  return (
    <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
      <DynamicForm
        inputs={underwriterUserInputs}
        mode={'CREATE'}
        onSave={createUnderwriterUser}
        redirectOnSuccess={'/users/underwriter'}
      />
    </Paper>
  );
});
